import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class TranslationService {
  language$ = new BehaviorSubject<string>(this.currentLang);

  get currentLang(): string {
    return localStorage.getItem('language') || 'es';
  }

  constructor(private translateService: TranslateService) {}

  setAppLanguage(lang: string): void {
    this.translateService.use(lang);
    localStorage.setItem('language', lang);
    this.language$.next(lang);
  }

  getLanguageObs(): Observable<string> {
    return this.language$.asObservable();
  }

  setLanguageObs(lang: string): void {
    this.language$.next(lang);
  }
}
